import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CsvSeleccionPromocionComponent } from './csv-seleccion-promocion/csv-seleccion-promocion.component';
import { CsvSeleccionProcesoComponent } from './csv-seleccion-proceso/csv-seleccion-proceso.component';
import { CsvEntrevistaSalidaComponent } from './csv-entrevista-salida/csv-entrevista-salida.component';
import { CsvCampeonCompromisoComponent } from './csv-campeon-compromiso/csv-campeon-compromiso.component';
import { CsvSeleccionCatalogosComponent } from './csv-seleccion-catalogos/csv-seleccion-catalogos.component';

const routes: Routes = [
  { path: 'empleados/seleccion-promocion', component: CsvSeleccionPromocionComponent },
  { path: 'empleados/seleccion-procesos', component: CsvSeleccionProcesoComponent },
  { path: 'empleados/seleccion-catalogos', component: CsvSeleccionCatalogosComponent },
  { path: 'empleados/entrevista-salida', component: CsvEntrevistaSalidaComponent },
  { path: 'empleados/encuesta-campeones', component: CsvCampeonCompromisoComponent },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SeleccionRoutingModule { }
